module.exports = __webpack_public_path__ + "img/video.b864b6a3.svg";